module.exports = __webpack_public_path__ + "img/con1-3y.cedf756e.png";